module.exports = __webpack_public_path__ + "static/media/common_bg.d0b8f498.png";